import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "has-first-letter-uppercase has-text-success is-size-5"
}
const _hoisted_2 = {
  key: 1,
  class: "has-first-letter-uppercase has-text-success is-size-5"
}
const _hoisted_3 = {
  key: 1,
  class: "w-100 h-100 center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { ref: "modal" }, {
    header: _withCtx(() => [
      (_ctx.stations && _ctx.stations.length < 3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('export_data.title', {stations: _ctx.names})), 1 /* TEXT */))
        : (_ctx.stations && _ctx.stations.length >= 3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('export_data.title_too_long')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
    ]),
    body: _withCtx(() => [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_n_alert, {
                  key: 0,
                  title: _ctx.$t('global.failure'),
                  type: "error",
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('global.try_again')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_form, { model: _ctx.exportDataForm }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  label: _ctx.$t('export_data.field.date_range'),
                  path: "formData.range"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_date_picker, {
                      value: _ctx.exportDataForm.range,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exportDataForm.range) = $event)),
                      width: "100%",
                      type: "datetimerange"
                    }, null, 8 /* PROPS */, ["value"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createVNode(_component_n_form_item, {
                  label: _ctx.$t('export_data.field.file'),
                  path: "formData.range"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_select, {
                      options: _ctx.fileTypeOptions,
                      value: _ctx.exportDataForm.filetype,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.exportDataForm.filetype) = $event)),
                      width: "100%"
                    }, null, 8 /* PROPS */, ["options", "value"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                (_ctx.stations.length > 1)
                  ? (_openBlock(), _createBlock(_component_n_form_item, {
                      key: 0,
                      label: _ctx.$t('export_data.field.stations')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_select, {
                          options: _ctx.stationOptions,
                          value: _ctx.exportDataForm.stations,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportDataForm.stations) = $event)),
                          multiple: "",
                          "max-tag-count": "responsive"
                        }, null, 8 /* PROPS */, ["options", "value"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_n_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_checkbox, {
                      checked: _ctx.singleFile,
                      "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.singleFile) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('export-data.export_in_one_file')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["checked"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model"])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_n_button, {
        disabled: _ctx.loading,
        class: "mr-2",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_n_button, {
        disabled: _ctx.loading,
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('station_list.export.download')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}